import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { UserInfos } from '../../types';

export type State = UserInfos[];

const initialState: State = [];

export const UsersSlice = createSlice({
  name: 'users',
  initialState,
  reducers: {
    onSetUsers: (state, action: PayloadAction<State>) => {
      const newState = [...state];
      for (const i of action.payload) {
        const index = newState.findIndex((o) => o.uid === i.uid);
        if (index === -1) {
          newState.push(i);
        } else {
          newState[index] = i;
        }
      }
      return newState.sort((a, b) => b.created_at - a.created_at);
    },
    onDeleteUsers: (state, action: PayloadAction<string[]>) => {
      return state.filter((s) => !action.payload.includes(s.uid));
    }
  }
});

export const { onSetUsers, onDeleteUsers } = UsersSlice.actions;

export default UsersSlice.reducer;
